import type { OccurrenceKanbanTemplate } from "./api";

type KanbanModelRecord = {
  status: string;
  kanban_column_id?: string;
  kanban_template_id?: string;
};

type KanbanPreviewColumn = {
  id: string;
  name: string;
  color: string;
};

export type GroupedKanbanPreviewColumn<T extends KanbanPreviewColumn> = T & {
  groupedCount: number;
};

export function groupKanbanColumnsByColor<T extends KanbanPreviewColumn>(
  columns: T[],
): GroupedKanbanPreviewColumn<T>[] {
  const grouped = new Map<string, GroupedKanbanPreviewColumn<T>>();

  for (const column of columns) {
    const colorKey = column.color.trim().toLowerCase();
    const existing = grouped.get(colorKey);
    if (existing) {
      existing.groupedCount += 1;
      continue;
    }
    grouped.set(colorKey, {...column, groupedCount: 0});
  }

  return [...grouped.values()];
}

export function resolveKanbanModelColumn(
  template: OccurrenceKanbanTemplate | undefined,
  row: KanbanModelRecord,
  statusAliases: Record<string, string[]> = {},
) {
  const columns = template?.columns || [];
  const assigned =
    row.kanban_template_id === template?.id
      ? columns.find((column) => column.id === row.kanban_column_id)
      : undefined;
  if (assigned) return assigned;
  const acceptedStatusKeys = new Set([row.status, ...(statusAliases[row.status] || [])]);
  return (
    columns.find(
      (column) => column.statusKey && acceptedStatusKeys.has(column.statusKey),
    ) || columns[0]
  );
}
